import type { RgbColor } from "utils/hslToRgb";
import type { FloorPlanZoneKind } from "../types";

export const NO_ZONE_RGB: RgbColor = [150, 150, 150];
// The one shape that holds every room without a zone.
export const NO_ZONE_SHAPE_ID = "zone-none";

// Zones next to each other in the list usually touch on the plan, so each next zone turns the hue by the golden angle, far from the one before.
export const ZONE_HUE_STEP_DEG = 137.508;
export const ZONE_SATURATION = 0.75;
export const ZONE_LIGHTNESS = 0.5;

// Typical wall thickness; the zone outline is stroked this wide to cover the walls between its rooms.
export const WALL_THICKNESS_M = 0.3;
export const UNCALIBRATED_WALL_STROKE_PT = 8;

// Drawn on the zone border, a non-scaling stroke, so in screen pixels (the agent viewer's dashes).
export const ZONE_DASH_BY_KIND: Record<FloorPlanZoneKind, string | undefined> =
  {
    functional: undefined,
    mep: undefined,
    circulation: "4 4",
    exterior: "10 6",
  };

export const WALL_RGB: RgbColor = [224, 0, 0];
export const DOOR_RGB: RgbColor = [208, 0, 208];
export const WINDOW_RGB: RgbColor = [0, 102, 255];
// Doors and windows are segments; drawn this many points either side so they are visible.
export const OPENING_HALF_WIDTH_PT = 4;
// How far beside an opening to look for its rooms, nearest first; the last step is the detector's reach (0.8 m).
export const ROOM_SEARCH_STEPS_M = [0.3, 0.5, 0.8];
export const UNCALIBRATED_ROOM_SEARCH_STEPS_PT = [12, 20, 32];

// A long name would span the whole plan, so the label shows its start only.
export const LABEL_MAX_CHARACTERS = 56;
